import { ProductType } from "motty-utils";
export const productToString = (product) => {
    switch (product) {
        case ProductType.ConsumerLoan:
            return 'Consumer loan';
        case ProductType.CreditCard:
            return 'Credit card';
        case ProductType.Mortgage:
            return 'Mortgage';
    }
};
